import { render, staticRenderFns } from "./show.vue?vue&type=template&id=655bf51e&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=655bf51e&prod&scoped=true&lang=less"
import style1 from "./show.vue?vue&type=style&index=1&id=655bf51e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655bf51e",
  null
  
)

export default component.exports